import app from '@frontend/application-container';
import common from '../index.module.scss';
import { SettingsEntrySingleLine } from '../settings-entry';
import { img } from '@phi/components';
import { h } from 'vue';
import { Background } from '@frontend/Colours';
import { Flex } from '@phi/components/layout';
import { BackgroundsIcon } from '..';

const bgblack = 'img/bgblack.webp';
const bgwhite = 'img/bgwhite.webp';
const bglightgray = 'img/bglightgray.webp';
const bgdarkgray = 'img/bgdarkgray.webp';

export function BackgroundPicker() {
    return SettingsEntrySingleLine(
        'Scene background',

        undefined,

        img(BackgroundsIcon, 'Scene background'),

        h(Flex, { direction: 'row', gap: 'tight' }, () => [
            h('button', {
                class: {
                    btn: true,
                    [common.image_button]: true,
                    [common.active]: app.settings.background === Background.white,
                },
                'data-toggle': 'popover',
                'data-html': true,
                title: 'White',
                'data-content': 'White background.',
                onClick: () => app.settings.background = Background.white,
            }, img(bgwhite)),
            h('button', {
                class: {
                    btn: true,
                    [common.image_button]: true,
                    [common.active]: app.settings.background === Background.darkgray,
                },
                'data-toggle': 'popover',
                'data-html': true,
                title: 'Dark gray',
                'data-content': 'Dark gray background.',
                onClick: () => app.settings.background = Background.darkgray,
            }, img(bgdarkgray)),
            h('button', {
                class: {
                    btn: true,
                    [common.image_button]: true,
                    [common.active]: app.settings.background === Background.black,
                },
                'data-toggle': 'popover',
                'data-html': true,
                title: 'Black',
                'data-content': 'Black background.',
                onClick: () => app.settings.background = Background.black,
            }, img(bgblack)),
        ]),
    );
}
